import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans as zoram, lineHeightLoose, fontSize18, fontWeightLight, fontWeightSemiBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { AppearanceInvert } from "@churchofjesuschrist/eden-appearance";
import { jsx as _jsx } from "react/jsx-runtime";
const Container1 = styled.div.withConfig({
  componentId: "sc-nsiojc-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightLight, lineHeightLoose, fontSize18, shared, fontWeightSemiBold);
const Text1 = _ref => {
  let {
    children,
    renderAs = "div",
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(AppearanceInvert, {
    inverted: props.inverted,
    children: /*#__PURE__*/_jsx(Container1, {
      as: renderAs,
      ...props,
      children: children
    })
  });
};
Text1.displayName = "Text1";
Text1.propTypes = {
  /** Content */
  children: PropTypes.node.isRequired,
  /** The HTML tag or custom React element to render as. */
  renderAs: PropTypes.elementType,
  /** Whether to apply styles that help the text stand out on a dark background */
  inverted: PropTypes.bool
};
export default Text1;